import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { CoreServiceService } from 'src/app/services/core/core-service.service';
import { MessageService } from 'src/app/services/message/message.service';
import { environment } from 'src/environments/environment';
import {
    trigger,
    state,
    style,
    animate,
    transition,
} from '@angular/animations';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { DialogVideo } from 'src/app/pages/home/home.component';
import { Subscription } from 'rxjs';
import { ProfileComponent } from 'src/app/pages/profile/profile.component';
import { NavigationEnd, Router } from '@angular/router';
import { DashboardDialogComponent, InvitationDialogComponent } from '../dashboard-menu/dashboard-menu.component';
import { v4 as uuidv4 } from 'uuid';
import { filter } from 'rxjs/operators';
/** @title Responsive sidenav */
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    animations: [
        trigger('hamburguerX', [
            state('hamburguer', style({})),
            state('topX', style({
                transform: 'rotate(45deg)',
                transformOrigin: 'left',
                margin: '6px',
                position: 'relative',
                top: '-5px'
            })),
            state('hide', style({
                opacity: 0
            })),
            state('bottomX', style({
                transform: 'rotate(-45deg)',
                transformOrigin: 'left',
                margin: '6px',
                width: '30px'
            })),
            transition('* => *', [
                animate('0.2s')
            ]),
        ]),
    ],
})
export class HeaderComponent implements OnInit, AfterViewInit {
    isHamburguer = true;
    userData : any;
    currentUser: any;
    lang = 'fr';
    isOpenMenu = false;
    loggedIn = this.authService.logIn;
    startLoad = true;
    name: string;
    profile: string;
    commonRef: string;
    inviteBadge = 0;
    userManager = false;
    userEmail = '';
    hideNav = localStorage.getItem('hideNav') && localStorage.getItem('hideNav') !== "0" ? 1 : 0;
    idonglet = null;
    isProjectVisible: boolean = false;
    allNotif: 0;
    mode: 'collaboratif' | 'cooperatif' = 'collaboratif';
    showInfo = false;
    @ViewChild('popupInfo', {static: false}) popupInfo!: ElementRef;

    constructor(private translate: TranslateService,
        private messageService: MessageService,
        public authService: AuthService,
        public dialog: MatDialog,
        private router: Router,
        private coreService: CoreServiceService) {
          this.router.events
          .pipe(filter(event => event instanceof NavigationEnd))
          .subscribe(() => {
            this.checkUrl();
          });

        this.checkUrl();
    }

    @HostListener('document:click', ['$event'])
    clickOutside(event: Event): void {
      if (
        this.showInfo &&
        this.popupInfo &&
        !this.popupInfo.nativeElement.contains(event.target)
      ) {
        this.showInfo = false;
      }
    }

    toggleInfo() {
      this.showInfo = !this.showInfo;
    }

    onMouseEnter(): void {
      console.log("enter")
      this.showInfo = true;
    }

    onMouseLeave(): void {
      console.log("leave")
      this.showInfo = false;
    }

    setMode(value: 'collaboratif' | 'cooperatif') {
      this.mode = value;
    }

    checkUrl() {
      this.isProjectVisible = !this.router.url.includes('project') && !this.router.url.includes('homes') && !this.router.url.includes('entreppayment') && !this.router.url.includes('storage') && !this.router.url.includes('statistique');
    }

    onChosenProject(IdProjectChosen) {
      /*this.GED = false;
      this.ID = IdProjectChosen;
      if (this.appged) {
        this.appged.reset();
      }
      if (this.singleproject) {
        this.singleproject.projecthasChange(IdProjectChosen);
      }*/
      this.messageService.setChosenProject(IdProjectChosen);
    }
  
    onProjectChanged(libelle) {
      this.messageService.setLibelleProject(libelle);
      /*if (this.singleproject) {
        this.singleproject.projectlibChanged(libelle);
      }*/
    }
  
    onNotificationsChanged(total) {
      console.log("toooot "+total)
      this.messageService.setNotifProject(total);
      /*if (this.singleproject) {
        this.singleproject.projectlibChanged(libelle);
      }*/
    }

    onImageChanged(url) {
      this.messageService.setImageProject(url);
    }

    goToProjectList(){
      this.authService.projectshowed.next(null);
      this.router.navigate(['/']);
    }

    ngAfterViewInit(): void {
        this.authService.endLoading.subscribe((term) =>{ 
            if(term == "1"){
                console.log("is connected")
                this.authService.getGlobalNotification().subscribe(res => {
                  this.allNotif = res['hydra:member']['all'];
                })
                this.authService.getUserInvitation(0, 10).subscribe(res => {
                  this.inviteBadge = res['hydra:totalItems'];
                });
                setTimeout(()=>{
                    this.startLoad = false;
                    this.userData = JSON.parse(localStorage.getItem('currentUser'));
                }, 500);
            }
          });
          this.authService.mode$.subscribe(mode => {
            this.mode = mode;
          });
    }

    ngOnInit() {
        this.idonglet = uuidv4();
        this.messageService.setOngletId(this.idonglet);
        this.hideNav = localStorage.getItem('hideNav') && localStorage.getItem('hideNav') !== "0" ? 1 : 0;
        this.isHamburguer = this.hideNav == 0 ? true : false;
        if(localStorage.getItem('currentUser')){
          this.currentUser = JSON.parse(localStorage.getItem('currentUser'))['id'];
          this.userData = JSON.parse(localStorage.getItem('currentUser'));
          this.userEmail = this.userData['email'];
          if(this.userData['roles'].includes("ROLE_MANAGER")){
              this.userManager = true;
            }
        }
        this.getCurrentCompany();
      this.messageService.obcompanyloaded.subscribe(res => {
        this.getCurrentCompany();
      })
      this.authService.getGlobalNotification().subscribe(res => {
        this.allNotif = res['hydra:member']['all'];
        //console.log("allNotif : "+this.allNotif);
      })
      this.authService.obnotifupdated.subscribe((res) =>{
        this.authService.getGlobalNotification().subscribe(res => {
          this.allNotif = res['hydra:member']['all'];
          //console.log("allNotif : "+this.allNotif);
        })
      });
        this.authService.getUserInvitation(0, 10).subscribe(res => {
          this.inviteBadge = res['hydra:totalItems'];
        });
        this.authService.obInviteBadge.subscribe((res) => {
          //console.log("invv "+res['hydra:totalItems'])
            this.inviteBadge = res['hydra:totalItems'];
          });
          this.authService.obreceiveInvitation.subscribe((idMessage) =>{ 
            //console.log("Iinvitation meme compte ")
            if(this.inviteBadge > 0) this.inviteBadge = this.inviteBadge -  1;
          });
        this.messageService.getTranslate()
            .subscribe(
                (data) => {
                    this.lang = data;
                }
            )
        /*if(localStorage.getItem('currentUser')){
            this.currentUser = JSON.parse(localStorage.getItem('currentUser'))['id'];
            this.userData = JSON.parse(localStorage.getItem('currentUser'));
            this.userEmail = this.userData['email'];
            if(this.userData['roles'].includes("ROLE_MANAGER")){
                this.userManager = true;
              }
        }*/
        
        this.authService.obconnect.subscribe((idMessage) =>{ 
            this.authService.getUserInvitation(0, 10).subscribe(res => {
              this.inviteBadge = res['hydra:totalItems'];
              if(localStorage.getItem('currentUser')){
                this.currentUser = JSON.parse(localStorage.getItem('currentUser'))['id'];
                this.userData = JSON.parse(localStorage.getItem('currentUser'));
                this.userEmail = this.userData['email'];
                if(this.userData['roles'].includes("ROLE_MANAGER")){
                    this.userManager = true;
                  }
            }
            });
            //console.log("connecteddd");
            this.currentUser = JSON.parse(localStorage.getItem('currentUser'))['id'];
            this.userData = JSON.parse(localStorage.getItem('currentUser'));
        });

        this.authService.photoHeader.subscribe((term) =>{ 
          if(term){
            //console.log("ress "+term)
            this.userData.imageUrl = term;
            this.getAvatarlUrl(term);
          }
          //console.log('dans le smarnumber idmessage ==> '+idMessage);
        });

        
        this.authService.photoCompHeader.subscribe((term) =>{ 
          if(term){
            //console.log("ress "+term)
            this.userData.comImage = term;
            this.getCompanyUrl(term);
          }
          //console.log('dans le smarnumber idmessage ==> '+idMessage);
        });

        this.authService.obUpdateProfile.subscribe((res) => {
          if(res === 1){
            this.getCurrentUser();
          } 
        });

        this.authService.obUpdateCompany.subscribe((message) => {
          if(message){
            this.setCompanyImage(message);
          } 
        });

        this.authService.obUpdateCompname.subscribe((res) => {
          if(res){
              this.userData.comName = res;
              this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
              this.currentUser.comName = res;
              localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
          } 
        });

        this.authService.obInviteInstant.subscribe((res) => {
          if(res === 1){
            this.inviteBadge += 1;
          } else this.inviteBadge -= 1;
        });
        this.authService.endLoading.subscribe((term) =>{ 
            if(term == "1"){
                setTimeout(()=>{
                    this.startLoad = false;
                }, 500);
            }
          });
        
        
    }

    setCompanyImage(message = null){
      if(message){
        var logo  = message.res.logo;
        this.userData.comImage = logo;
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.currentUser.comImage = logo;
        localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
      }
     }

    getCurrentUser(){
      var iduser = JSON.parse(localStorage.getItem('currentUser')).id;
       this.authService.getInfoContact(iduser)
       .subscribe( dataContact => {
          this.userData.imageUrl = dataContact['imageUrl'];
          this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
          this.currentUser.imageUrl = dataContact['imageUrl'];
          localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
       }, (error) => {
           alert('une erreur est survenue getCurrentUser update profile image');
       });
   
     }

     getCurrentCompany(){
      var idcompany = JSON.parse(localStorage.getItem('currentUser')).compId;
       this.authService.getInfoCompany(idcompany)
       .subscribe( dataContact => {
          var logo  = dataContact['logo'];
          if(logo) {
            this.userData.comImage = logo;
            this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
            this.currentUser.comImage = logo;
            localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
          }
       }, (error) => {
           console.log('Uh-oh, an error occurred! : ' +JSON.stringify(error));
       });
   
     }

     checkImageExists(url: string): void {
      const img = new Image();
      img.crossOrigin = 'Anonymous';  // Si tu veux permettre CORS
      img.src = url;
    
      img.onerror = (error) => {
        console.log("Erreur lors du chargement de l'image header", error);
        this.getCurrentCompany();
      };
    }

    onImageError() {
    }

    getCompanyUrl(avatarLink) {
      if(!avatarLink) return '../../assets/img/default-avatar.png';
      return environment.server_url+"/media/project_img/" + avatarLink;
    }

    goToDashboard(){
      this.authService.currentProjectId.next(null);
      this.router.navigate(['/dashboard']);
    }

    goToDashboardSuivi(){
      this.authService.currentProjectId.next(null);
      this.router.navigate(['/dashboardsuivi']);
    }

    changeLang() {
        this.translate.use(this.lang);
        this.messageService.setTranslate(this.lang);
    }
    useLanguage(language: string) {
        this.translate.use(language);
        this.messageService.setTranslate(language);
    }

    logout() {
        this.authService.logout();
    }

    selectProject(){
        this.authService.selectProject.emit("select");
    }

    changeModeProject(value: 'collaboratif' | 'cooperatif') {
      if(value == this.mode) return;
      this.mode = value;
      this.authService.changeModeProject.emit("change");
    }

    openParams(){
        this.authService.selectProject.emit("params");
    }

    openEntreprise(){
      this.authService.selectProject.emit("entreprise");
    }

    public openSidebar() {
        this.hideNav = this.hideNav == 0 ? 1 : 0;
        this.coreService.toggleSidebar.emit(this.hideNav);
        this.isHamburguer = !this.isHamburguer;
    }
    public openNavbarmobile() {
        this.isOpenMenu = !this.isOpenMenu;
    }

    openDialog(): void {
        const dialogRef = this.dialog.open(DialogVideo, {
          width: '700px',
          height: '450px',
          data: {}
        });
    
        dialogRef.afterClosed().subscribe(result => {
          //console.log('The dialog was closed');
        });
    }

    getAvatarlUrl(avatarLink){
        return environment.server_url+avatarLink;
      }

    
      openProfilDialog() {
        this.dialog.closeAll();
        const dialogConfig = new MatDialogConfig();
        dialogConfig.panelClass = 'contactpanel';
        dialogConfig.id = 'balchal718';
        dialogConfig.width = '550px';
        dialogConfig.autoFocus = false;
        dialogConfig.data = { name: this.name, profile: this.profile, commonRef: this.commonRef };
        //const dialogRef = this.dialog.open(ProfileComponent, dialogConfig);
        const dialogRef = this.dialog.open(ProfileComponent, {
          data: { name: this.name, profile: this.profile, commonRef: this.commonRef },
          panelClass: 'profileclass',
          backdropClass: 'custom-backdrop'
        });
    
        dialogRef.afterClosed().subscribe((result: any) => {
        });
    
      }

      showLanguage(){
        this.authService.selectProject.emit("langue");
      }

      showInvitation() {
        this.authService.selectProject.emit("invitation");
      }

      openDialogContacts() {
        this.dialog.closeAll();
        const dialogConfig = new MatDialogConfig();
        dialogConfig.panelClass = 'contactpanel';
        dialogConfig.id = 'balchal717';
        dialogConfig.width = '550px';
        dialogConfig.autoFocus = false;
        dialogConfig.data = { name: this.name, profile: this.profile, commonRef: this.commonRef };
        const dialogRef = this.dialog.open(DashboardDialogComponent, dialogConfig);
    
        dialogRef.afterClosed().subscribe((result: any) => {
          if (result) {
            this.profile = result;
            this.router.navigate(['/profile/' + result]);
          }
        });
    
      }
    
}
